import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { SmartCatalogModality } from "@/services/walter-assistant";
import { Blend, Headset, LucideIcon, TvMinimalPlay } from "lucide-react";

import { ModalityDisplayKind, resolveModalityDisplay } from "./smart-catalog.utils";

const MODALITY_ICONS: Record<Exclude<ModalityDisplayKind, "unknown">, LucideIcon> = {
    asynchrone: TvMinimalPlay,
    synchrone: Headset,
    hybride: Blend
};

type Props = {
    modality: SmartCatalogModality;
    className?: string;
};

/** Badge neutre de modalité avec icône Lucide. */
export function ModalityBadge({ modality, className }: Props) {
    const display = resolveModalityDisplay(modality);
    const Icon = display.kind !== "unknown" ? MODALITY_ICONS[display.kind] : null;

    return (
        <Badge variant="outline" className={cn("gap-1 border-gray-200 bg-gray-50 px-2 py-0.5 font-medium text-gray-700 hover:bg-gray-50", className)}>
            {Icon ? <Icon className="size-3.5 shrink-0" aria-hidden /> : null}
            {display.label}
        </Badge>
    );
}
